export { default as ReminderModal } from './ReminderModal';
export type { ReminderConfig } from './ReminderModal';
